import React, { useLayoutEffect, useState } from "react";
import { WhitelistUsersList } from "./WhitelistUsersList";
import { graphql, useLazyLoadQuery, useMutation } from "react-relay";
import { useNavigationHeaderOptions } from "@/src/common/navigationHeaderOptions";
import { LazyQueryNetworkBoundrary } from "@/src/components/mobile/QueryNetworkBoundrary";
import { TeamWhitelistUsersQuery } from "./__generated__/TeamWhitelistUsersQuery.graphql";
import { TeamWhitelistUsersMutation } from "./__generated__/TeamWhitelistUsersMutation.graphql";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";

type Props = {
  teamId: string;
  setOptions: (options: any) => void;
  goBack: () => void;
};

export function TeamWhitelistUsers(props: Props) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fetchKey) => <InnerTeamWhitelistUsers fetchKey={fetchKey} {...props} />}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerTeamWhitelistUsers(props: Props & { fetchKey: string }) {
  const data = useLazyLoadQuery<TeamWhitelistUsersQuery>(
    graphql`
      query TeamWhitelistUsersQuery($teamId: ID!) {
        store {
          ...WhitelistUsersList_Store
          team(id: $teamId) {
            whitelistUsers {
              user {
                id
              }
            }
          }
        }
      }
    `,
    {
      teamId: props.teamId,
    },
    {
      fetchKey: props.fetchKey,
      fetchPolicy: "store-and-network",
    }
  );

  const [whitelistUserIds, setWhitelistUserIds] = useState<string[]>(
    data.store.team?.whitelistUsers.map((user) => user.user.id) ?? []
  );

  console.log(JSON.stringify({ whitelistUserIds }, null, 2));

  const [saveWhitelist, saveWhitelistLoading] =
    useMutation<TeamWhitelistUsersMutation>(graphql`
      mutation TeamWhitelistUsersMutation(
        $teamId: ID!
        $whitelistUserIds: [ID!]!
      ) {
        team(id: $teamId) {
          updateWhitelistUserIds(newWhitelistUserIds: $whitelistUserIds) {
            whitelistUsers {
              user {
                id
              }
            }
          }
        }
      }
    `);

  const getNavigationHeaderOptions = useNavigationHeaderOptions();
  const intl_tokens = useIntlTokens();

  useLayoutEffect(() => {
    props.setOptions(
      getNavigationHeaderOptions({
        type: "SAVE",
        onSave: () => {
          saveWhitelist({
            variables: {
              teamId: props.teamId,
              whitelistUserIds,
            },
            onCompleted: () => {
              props.goBack();
            },
            onError: (error) => {
              console.error(error);
            },
          });
        },
        title: intl_tokens.AssignPermissions,
        saveLoading: saveWhitelistLoading,
        onCancel: () => {
          props.goBack();
        },
      })
    );
  }, [
    getNavigationHeaderOptions,
    props.teamId,
    props.setOptions,
    saveWhitelist,
    whitelistUserIds,
    saveWhitelistLoading,
    props,
    intl_tokens.AssignPermissions,
  ]);

  return (
    <WhitelistUsersList
      store={data.store}
      whitelistUserIds={whitelistUserIds}
      setWhitelistUserIds={setWhitelistUserIds}
    />
  );
}
